import { createContext, useState } from "react";

const ModalContext = createContext({});

export const ModalProvider = ({ children }) => {
    const [termsAndConditionModal, setTermsAndConditionModal] = useState(false);

    const toggleTermsAndConditionModal = () => {
        setTermsAndConditionModal(prev => !prev);
    }

    return (
        <ModalContext.Provider value={{
            toggleTermsAndConditionModal: {
                state: termsAndConditionModal,
                toggle: toggleTermsAndConditionModal
            },
        }}>
            {children}
        </ModalContext.Provider>
    )
}

export default ModalContext;